/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
import React, { memo, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { Dialog, DialogContent, DialogTitle, IconButton, Link } from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'
import CloseIcon from '@mui/icons-material/Close'
import DownloadIcon from '@mui/icons-material/Download'
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'

import { GridActionsCellItem } from '@mui/x-data-grid'

// import { checkPermissions } from '../../../components/AccessControl'
import { getSimulations, searchSimulations } from '../../../actions'
import {
  attributesNames,
  // simulationModes,
  simulationStatus,
  simulationStatusStoppable,
  simulationStatusDeletable,
  userRightTypes,
  dialogSize
} from '../../../constants'
import { checkErrorResponse, DebugView, isDebug, Logger, LoggerTypes } from '../../../utils'
import {
  Button,
  buttonModes,
  buttonTypes,
  DataGrid,
  FormTitle,
  Icon,
  iconNames,
  AccessControl
} from '../../../components'
import {
  SimulationActionDialogCancel,
  SimulationActionDialogDelete,
  SimulationActionDialogDownloadLogs,
  SimulationActionDialogWrapper,
  SimulationConditionCard,
  SimulationDialogLaunch
} from '../../simulations'
import './style.scss'

const useStyles = makeStyles((theme) =>
  createStyles({
    closeStyle: {
      border: `1px solid ${theme.palette.primary.main}`
    },
    closeIconStyle: {
      color: theme.palette.primary.main
    }
  })
)

const SimulationDialogList = ({ currentProject, currentScenario, parameters, variables, resources, setOpenDialog }) => {
  const { t } = useTranslation()
  const styleClasses = useStyles()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()

  const [isLoading, setIsLoading] = useState(true)
  const [simulationSelected, setSimulationSelected] = useState(null)
  const [simulationConditionSelected, setSimulationConditionSelected] = useState(null)
  const [simulationDialogClass, setSimulationDialogClass] = useState(null)
  const [openSimulationDialog, setOpenSimulationDialog] = useState({ open: false, readOnly: false })
  const [openSimulationActionDialog, setOpenSimulationActionDialog] = useState(false)

  const [searchValue, setSearchValue] = useState('')
  const simulations = useSelector((state) => state.simulations) || {}

  let openDatagridActionDialog = false

  const _loadSimulations = () => {
    const pid = currentProject?.id || null
    const sid = currentScenario?.id || null

    dispatch(getSimulations(pid, sid))
      .then((res) => {
        Logger.trace(LoggerTypes.CONTROLLER, 'SimulationDialogList.dispatch(getSimulations(...)).then()', {
          res
        })
        // checkSnackbarOK(enqueueSnackbar, t, res)
        setIsLoading(false)
      })
      .catch((res) => {
        Logger.trace(LoggerTypes.WARN, 'SimulationDialogList.dispatch(getSimulations(...)).catch()', {
          res
        })
        checkErrorResponse(res, enqueueSnackbar, t)
        setIsLoading(false)
      })
  }

  useEffect(() => {
    _loadSimulations()
  }, [])

  const simulationItems = simulations.items || []

  // --

  const onClickReportUrl = (simulation) => {
    const env_vars = JSON.parse(localStorage.getItem('env_vars'))
    // const reportURL =
    //   simulation?.mode === simulationModes.SINGLE
    //     ? env_vars.SINGLE_RUN_REPORT_URL
    //     : simulation?.mode === simulationModes.MULTIPLE
    //     ? env_vars.MULTI_RUN_REPORT_URL
    //     : null
    const reportURL = env_vars.MULTI_RUN_REPORT_URL

    Logger.trace(LoggerTypes.CONTROLLER, 'SimulationDialogList.onClickReportUrl()', { reportURL, env_vars })
    window.open(`${reportURL} '${simulation.id}'`, '_blank')
  }

  const onCloseDialog = () => setOpenDialog(false)

  const onSearch = (txt) => {
    setSearchValue(txt)
    Logger.trace(LoggerTypes.CONTROLLER, 'SimulationDialogList.onSearch()', { txt })
    dispatch(searchSimulations(txt))
  }

  const onCreateSimulationClick = (e) => {
    e.stopPropagation()
    Logger.trace(LoggerTypes.CONTROLLER, 'SimulationDialogList.onCreateSimulationClick()', {})
    setOpenSimulationDialog({ open: true, readOnly: false })
  }

  const onRefreshSimulationClick = (e) => {
    e.stopPropagation()
    Logger.trace(LoggerTypes.CONTROLLER, 'SimulationDialogList.onRefreshSimulationClick()', {})
    _loadSimulations()
  }

  const onSimulationNameClick = (simulation, simulationCondition) => {
    // Logger.trace(LoggerTypes.CONTROLLER, 'SimulationDialogList.onSimulationNameClick()', {
    //   simulationId,
    //   simulationCondition
    // })
    setSimulationSelected(simulation)
    setSimulationConditionSelected(simulationCondition)
    setOpenSimulationDialog({ open: true, readOnly: true })
  }

  const onRenderDatagridName = (e) => {
    const simulation = e.row
    const condition = simulation?.while_conditions[0] || null
    // -- left operand
    const left_operand_attributeName = condition?.left_operand?.resource
      ? attributesNames.RESOURCES
      : condition?.left_operand?.variable
      ? attributesNames.VARIABLES
      : condition?.left_operand?.parameter
      ? attributesNames.PARAMETERS
      : null
    const left_operand_attribute = condition?.left_operand?.resource
      ? condition?.left_operand.resource
      : condition?.left_operand?.variable
      ? condition?.left_operand.variable
      : condition?.left_operand?.parameter
      ? condition?.left_operand.parameter
      : condition?.left_operand
    // -- right operand
    const right_operand_attributeName = condition?.right_operand?.resource
      ? attributesNames.RESOURCES
      : condition?.right_operand?.variable
      ? attributesNames.VARIABLES
      : condition?.right_operand?.parameter
      ? attributesNames.PARAMETERS
      : null
    const right_operand_attribute = condition?.right_operand?.resource
      ? condition?.right_operand.resource
      : condition?.right_operand?.variable
      ? condition?.right_operand.variable
      : condition?.right_operand?.parameter
      ? condition?.right_operand.parameter
      : condition?.right_operand
    // --
    const currentCondition = {
      left_operand: {
        attributesName: left_operand_attributeName,
        attribute: left_operand_attribute,
        value: condition?.left_operand?.value
      },
      operator: condition.operator,
      right_operand: {
        attributesName: right_operand_attributeName,
        attribute: right_operand_attribute,
        value: condition?.right_operand?.value
      }
    }

    return (
      <Link
        href="#"
        onClick={(evt) => {
          // Logger.trace(LoggerTypes.CONTROLLER, 'SimulationDialogList.onRenderDatagridName().onClick()', evt)
          evt.stopPropagation()
          onSimulationNameClick(simulation, currentCondition)
        }}
        disabled={false}
        // style={style}
        label="Click for action"
      >
        {e.row.name}
      </Link>
    )
  }

  const onSimulationActionClick = (simulation, dialogClass) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'SimulationDialogList.onSimulationActionClick()', {
      dialogClass
    })
    setSimulationSelected(simulation)
    setSimulationDialogClass(dialogClass)
    setOpenSimulationActionDialog(true)
  }

  const onRenderDatagridActions = (e) => {
    const simulation = e.row
    // Logger.trace(LoggerTypes.CONTROLLER, 'SimulationDialogList.onRenderDatagridActions()', e, simulation)
    return [
      <GridActionsCellItem
        key={'button-stop'}
        icon={<Icon name={iconNames.CIRCLE_CANCEL} size={18} />}
        onClick={(evt) => {
          evt.stopPropagation()
          Logger.trace(LoggerTypes.CONTROLLER, 'button-stop.LICK !', evt)
          onSimulationActionClick(simulation, SimulationActionDialogCancel)
        }}
        disabled={!simulationStatusStoppable.includes(e?.row?.status)}
        style={!simulationStatusStoppable.includes(e?.row?.status) ? { opacity: '0.7' } : null}
      />,

      <GridActionsCellItem
        key={'button-delete'}
        icon={<DeleteOutlineIcon />}
        onClick={(evt) => {
          evt.stopPropagation()
          Logger.trace(LoggerTypes.CONTROLLER, 'button-stop.LICK !', evt)
          onSimulationActionClick(simulation, SimulationActionDialogDelete)
        }}
        disabled={!simulationStatusDeletable.includes(e?.row?.status)}
        style={!simulationStatusDeletable.includes(e?.row?.status) ? { opacity: '0.7' } : null}
      />,

      <GridActionsCellItem
        key={'button-download-logs'}
        icon={<DownloadIcon />}
        onClick={(evt) => {
          evt.stopPropagation()
          Logger.trace(LoggerTypes.CONTROLLER, 'button-download-logs.CLICK !', evt)
          onSimulationActionClick(simulation, SimulationActionDialogDownloadLogs)
        }}
        disabled={
          ![simulationStatus.RUNNING].includes(e?.row?.status) && !simulationStatusDeletable.includes(e?.row?.status)
        }
        style={
          ![simulationStatus.RUNNING].includes(e?.row?.status) && !simulationStatusDeletable.includes(e?.row?.status)
            ? { opacity: '0.7' }
            : null
        }
      />,

      <IconButton
        key={'button-report'}
        onClick={() => onClickReportUrl(e.row)}
        disabled={
          // e?.row?.mode === simulationModes.SINGLE ||
          ![simulationStatus.FINISHED].includes(e?.row?.status)
        }
        isPopupVisible={openDatagridActionDialog}
      >
        <AssessmentOutlinedIcon />
      </IconButton>
    ]
  }

  const columnsSimulations = [
    {
      field: 'id',
      headerName: 'ID',
      renderCell: (e) => <DebugView type={'simulations'}>{e.row}</DebugView>,
      width: 220
    },
    {
      field: 'name',
      headerName: t('simulations.list.columns.name'),
      width: 220,
      editable: false,
      renderCell: onRenderDatagridName
    },
    {
      field: 'description',
      headerName: t('simulations.list.columns.description'),
      flex: 1,
      minWidth: 250
    },
    {
      field: 'start_date',
      headerName: t('simulations.list.columns.start_date'),
      width: 110
    },
    {
      field: 'while_conditions',
      headerName: t('simulations.list.columns.while_conditions'),
      width: 260,
      renderCell: (e) => {
        const condition = e.row?.while_conditions[0] || null
        // -- left operand
        const left_operand_attributeName = condition?.left_operand?.resource
          ? attributesNames.RESOURCES
          : condition?.left_operand?.variable
          ? attributesNames.VARIABLES
          : condition?.left_operand?.parameter
          ? attributesNames.PARAMETERS
          : null
        const left_operand_attribute = condition?.left_operand?.resource
          ? condition?.left_operand.resource
          : condition?.left_operand?.variable
          ? condition?.left_operand.variable
          : condition?.left_operand?.parameter
          ? condition?.left_operand.parameter
          : condition?.left_operand
        // -- right operand
        const right_operand_attributeName = condition?.right_operand?.resource
          ? attributesNames.RESOURCES
          : condition?.right_operand?.variable
          ? attributesNames.VARIABLES
          : condition?.right_operand?.parameter
          ? attributesNames.PARAMETERS
          : null
        const right_operand_attribute = condition?.right_operand?.resource
          ? condition?.right_operand.resource
          : condition?.right_operand?.variable
          ? condition?.right_operand.variable
          : condition?.right_operand?.parameter
          ? condition?.right_operand.parameter
          : condition?.right_operand
        // --
        const currentCheck = {
          left_operand: {
            attributesName: left_operand_attributeName,
            attribute: left_operand_attribute,
            value: condition?.left_operand?.value
          },
          operator: condition.operator,
          right_operand: {
            attributesName: right_operand_attributeName,
            attribute: right_operand_attribute,
            value: condition?.right_operand?.value
          }
        }
        return <SimulationConditionCard currentCheck={currentCheck} onDelete={null} />
      }
    },
    {
      field: 'weather_impact',
      headerName: t('simulations.list.columns.weather_impact'),
      width: 80,
      // renderCell: (e) => <Icon name={e.row.weather_impact ? iconNames.CHECK_OK : iconNames.CHECK_EMPTY} size={18} />
      renderCell: (e) => (e.row.weather_impact ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />)
    },
    {
      field: 'mode',
      headerName: t('simulations.list.columns.mode'),
      width: 80,
      renderCell: (e) => <span className={`cartouche mode-${e.row.mode}`}>{e.row.mode}</span>
    },
    {
      field: 'status',
      headerName: t('simulations.list.columns.status'),
      width: 100,
      renderCell: (e) => (
        <span className={`cartouche status-${e.row.status}`}>{t(`simulations.list.status.${e.row.status}`)}</span>
      )
    },
    {
      field: 'runs_processed',
      headerName: t('simulations.list.columns.runs_processed'),
      width: 110,
      renderCell: (e) => (
        <span>
          {e.row.runs_processed} / {e.row.runs_total}
        </span>
      )
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: t('common.actions'),
      width: 150,
      editable: false,
      getActions: onRenderDatagridActions
    }
  ]

  Logger.trace(LoggerTypes.CONTAINER, 'SimulationDialogList.render()', {
    currentProject,
    currentScenario,
    parameters,
    simulations,
    isLoading
  })

  return (
    <Dialog
      fullWidth={true}
      open={true}
      maxWidth={dialogSize.EXTRA_LARGE}
      width={dialogSize.EXTRA_LARGE}
      onClose={onCloseDialog} // <-- close while clicking on background
      aria-labelledby="form-dialog-title"
      className="SimulationDialogList"
    >
      <DialogTitle id="form-dialog-title">
        <FormTitle
          title={t('simulations.list.title')}
          icon={iconNames.SIMULATION}
          iconSize={26}
          style={{ fontSize: '20px' }}
        />
        <Button
          mode={buttonModes.SECONDARY_ACTION}
          type={buttonTypes.BUTTON}
          tooltip={t('common.close')}
          icon={<CloseIcon className={styleClasses.closeIconStyle} />}
          onClick={onCloseDialog}
          className={`headerButton ${styleClasses.closeStyle}`}
        />
      </DialogTitle>
      <DialogContent>
        <DialogContent>
          <div className="right">
            <div className="top">
              <div className="btCont">
                <AccessControl userPermissions={[userRightTypes.SCENARIO_EDIT]} renderNoAccess={() => <></>}>
                  <Button
                    mode={buttonModes.HEADER}
                    type={buttonTypes.BUTTON}
                    tooltip={t('simulations.list.button_launch.tooltip')}
                    onClick={onCreateSimulationClick}
                    icon={<Icon name={iconNames.PLUS} size={14} />}
                  />
                </AccessControl>

                <Button
                  mode={buttonModes.HEADER}
                  type={buttonTypes.BUTTON}
                  tooltip={t('simulations.list.button_refresh.tooltip')}
                  onClick={onRefreshSimulationClick}
                  icon={<Icon name={iconNames.INTERACTION} size={14} />}
                />
              </div>
            </div>
            <div className="main">
              <DataGrid
                isLoading={isLoading}
                checkboxSelection={false}
                hideFooterPagination={true}
                disableColumnFilter={false}
                exportData={true}
                // -- Columns
                columns={columnsSimulations}
                columnVisibilityModel={{ id: isDebug() }}
                // -- Rows
                rows={simulationItems}
                // -- Selection
                disableRowSelectionOnClick={true}
                isRowSelectable={() => false}
                // selectionModel={simulationSelected}
                // -- Search
                searchValue={searchValue}
                onSearch={onSearch}
                // -- End row line actions
                // actionsButtons={[]}
              />
            </div>
          </div>
        </DialogContent>
      </DialogContent>
      {openSimulationDialog.open && (
        <SimulationDialogLaunch
          currentProject={currentProject}
          currentScenario={currentScenario}
          parameters={openSimulationDialog.readOnly ? null : parameters}
          variables={openSimulationDialog.readOnly ? null : variables}
          resources={openSimulationDialog.readOnly ? null : resources}
          simulation={openSimulationDialog.readOnly ? simulationSelected : null}
          simulationWhileCondition={openSimulationDialog.readOnly ? simulationConditionSelected : null}
          setOpenDialog={setOpenSimulationDialog}
        />
      )}
      {openSimulationActionDialog && (
        <SimulationActionDialogWrapper
          DialogClass={simulationDialogClass}
          extraDialogAttribute={{
            currentProject,
            currentScenario,
            simulation: simulationSelected
          }}
          openDialog={openSimulationActionDialog}
          setOpenDialog={setOpenSimulationActionDialog}
        />
      )}
    </Dialog>
  )
}

SimulationDialogList.displayName = 'SimulationDialogList'

SimulationDialogList.propTypes = {
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  // -- Scenario's Attributes
  parameters: PropTypes.arrayOf(PropTypes.object),
  resources: PropTypes.arrayOf(PropTypes.object),
  variables: PropTypes.arrayOf(PropTypes.object)
}

SimulationDialogList.defaultProps = {
  currentProject: null,
  currentScenario: null,
  setOpenDialog: () => {},
  // -- Scenario's Attributes
  parameters: [],
  resources: [],
  variables: []
}

export default memo(SimulationDialogList)
